/* @ngInject */
const settingInit = (

) => {
  const self = {}

  return self
}
export default settingInit



// WEBPACK FOOTER //
// ./public/javascript/sygem/setting/services/init.service.js